/**
 * 公用方法
 */
/**
 * 本地缓存储存
 * @param {String} key [键名]
 * @param {*} val [值]
 */
export const setStorage = (key, val) => {
    if (typeof val !== 'string') {
        val = JSON.stringify(val)
    }
    window.localStorage.setItem(key, val)
}
/**
 * 获取本地缓存
 * @param {String} key [键名]
 */
export const getStorage = (key) => {
    return window.localStorage.getItem(key);
}
/**
 * 删除本地缓存
 * @param {String} key [键名]
 */
export const removeStorage = (key) => {
    window.localStorage.removeItem(key);
}
/**
 * 清空本地缓存
 */
export const clearStorage = () => {
    window.localStorage.clear();
    window.sessionStorage.clear();
}
/**
 * 防抖函数
 * @param func 需要包装的函数
 * @param delay 延迟时间，单位ms
 * @param immediate 是否默认执行一次(第一次不延迟)
 */
export const debounce = (func, delay, immediate = false) => {
    let timer = null
    return (...args) => {
        if (immediate) {
            func.apply(this, args) // 确保引用函数的指向正确，并且函数的参数也不变
            immediate = false
            return
        }
        clearTimeout(timer)
        timer = setTimeout(() => {
            func.apply(this, args)
        }, delay)
    }
}

/**
 * 超过多少位字符后用...代替
 * @param {string} str 字符串
 * @param {number} digit 保留位数
 * @returns {string}
 */
export const strEllipsis = (str = '', digit = 5) => {
    const len = str.length || 0;
    if (len > digit) {
        str = str.slice(0, digit) + '...'
    }
    return str
}

/**
 * 数字格式化
 * @param {number} val 值
 * @param {number} digit 保留位数
 * @param {boolean} mantissa 小于1w时是否保留小数
 */
export function numFormat(val = 0, digit = 2, mantissa = false) {
    val = Number(val);
    let res = val;
    if (val < 10000) {
        mantissa && (res = val.toFixed(digit))
    }
    if (val >= 10000 && val < 100000000) {
        res = (val / 10000).toFixed(digit) + '万'
    }
    if (val >= 100000000) {
        res = (val / 100000000).toFixed(digit) + '亿'
    }
    return res;
}

/**
 * File转base64
 * @param file 
 * @return base64
 * */
export function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        let fileResult = "";
        //开始转
        reader.onload = () => {
            fileResult = reader.result;
        };
        //转失败
        reader.onerror = (error) => {
            reject(error);
        };
        //结束 resolve
        reader.onloadend = () => {
            resolve(fileResult);
        };
        reader.readAsDataURL(file);
    });
}

/**
 * 数组分组
 * @param {array} arr // 需要分组的数组
 * @param {string | function} generateKey // 获取按哪个key分组的方法
 * @returns {object}
 */
export function groupBy(arr, generateKey) {
    if (typeof generateKey === 'string') {// 参数归一化
        const propName = generateKey;
        generateKey = (item) => item[propName];
    }
    const result = {};
    arr.forEach(item => {
        const key = generateKey(item);
        if (!result[key]) {
            result[key] = [];
        }
        result[key].push(item);
    });
    return result;
}

/**
 * 将元素滚动到底部
 * @param { string } selector css选择器
 */
export function scrollToBottom(selector) {
    const el = document.querySelector(selector);
    el.scrollTop = el.scrollHeight;
}

/**
 * 将html转为纯文本
 * @param { string } html
 */
export function html2text(html) {
    return html.replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi, '').replace(/<[^>]+?>/g, '').replace(/\s+/g, ' ').replace(/ /g, ' ').replace(/>/g, ' ');
}

/**
 * 打开新窗口
 * @param { string } url
 */
export function openWindow(url) {
    window.open(url, '_blank');
}

/**
 * 判断文本是不是中文
 * @param { string } str
 * @returns { boolean }
 */
export function isChinese(str) {
    return /[\u4e00-\u9fa5]/.test(str);
}

/**
 * 判断文本是不是英文
 * @param { string } str
 * @returns { boolean }
 */
export function isEnglish(str) {
    // 使用正则表达式匹配非英文字符（包括空格、标点符号等英文常用字符除外）  
    // 注意：这个正则表达式可能需要根据实际需求进行调整  
    // 这里假设我们只排除ASCII码表中英文范围外的字符，但保留了一些常见的标点符号  
    const nonEnglishRegex = /[^\x00-\x7F\s\.,\-_'"?!;:()\[\]\{\}\\\/\*0-9]/g;

    // 计算非英文字符的数量  
    const nonEnglishCount = (str.match(nonEnglishRegex) || []).length;

    // 设定一个阈值，比如非英文字符占总字符数的比例不超过10%  
    // 这里假设如果非英文字符数量占总字符数的比例小于10%，则认为主要是英文  
    const threshold = 0.1;
    const totalLength = str.length;
    const isMostlyEnglish = (nonEnglishCount / totalLength) < threshold;

    return isMostlyEnglish;
} 